<!--
 * @Author: 
 * @LastEditTime: 2022-07-26 17:09:50
 * @Description: 
-->
<template>
  <div class="circle-item">
    <img src="../images/realTime.png" alt="" />
  </div>
</template>

<script>
export default {
  name: 'realMonitoring',
}
</script>

<style lang="scss" scoped>

.circle-item {
  position: relative;
  a {
    position: absolute;
    font-weight: bold;
    font-size: 12px;
    &:active,
    &:hover {
      color: rgb(13, 216, 13);
      text-decoration: underline;
    }
  }
}
@import './specialStyle.scss';

</style>
